import { gql } from '@apollo/client/core';

export const getHomeScreenAppData = gql`
query {
  getHomeScreenAppData {
    sliderData {
      id
      featuredImage
      title
      description
      navigateTo
    }
    stickersData {
      id
      title
      url
      description
      entity
      quickCosts
      user {
        id
        firstname
        lastname
        avatar
        background
      }
      organization {
        id
        name
        avatar
        background
      }
      tags
      cost
      causes
      campaignType
      causes
      isCausesSearchAllowed
      raised
      donors
      isSpotlight
    }
  }
}`;

export const findPublicStaticPage = gql`
  query FindPublicStaticPage($isId: Boolean!, $idOrSlug: String!) {
    findPublicStaticPage(isId: $isId, idOrSlug: $idOrSlug) {
      id
      slug
      title
      greenGradientEnabled
      blocks {
        id
        sortOrder
        blockType
      }
      bannerBlocks {
        id
        title
        setFullWidth
        items {
          imageUrl
          deepLink
        }
      }
      searchBarBlocks {
        id
        searchType
        placeholderText
      }
      stickersBlocks {
        id
        title
        columnsCount
        stickersList
      }
      organizationsBlocks {
        id
        title
        organizationsList
      }
      richTextBlocks {
        id
        heading
        text
      }
      announcementBlocks {
        id
        text
        textColor
        textBackgroundColor
      }
      questionBlocks {
        id
        text
        questionId
        organizationId
      }
      collectionsBlocks {
        id
        title
        groups {
          title
          coverImageUrl
          organizationsList
        }
      }
      listBlocks {
        id
        title
        organizationsList
      }
      organizations {
        id
        name
        email
        avatar
        background
        organization_type
      }
      stickers {
        id
        title
        url
        thumbnailUrl
        cost
        published
        entity
        campaignType
        priceRange
        quickCosts
        sweepstakesSticker {
          entries
          entryCost
          id
          numberOfPrizesAndWinners
          prizes
          createdAt
          drawingDateTime
          aboutTheCause
          checkoutPageLegal
          approximateRetailValue
          experienceDateTime
          nonProfitBeneficiary
        }
        organization {
          id
          name
          avatar
          organization_type
        }
        user {
          id
          firstname
          lastname
          avatar
        }
      }
    }
  }
`;

export const mutateFeaturedQuestionAnswer = gql`
  mutation MutateFeaturedQuestionAnswer($questionId: UUID!, $input: FeaturedQuestionInput) {
    mutateFeaturedQuestionAnswer(questionId: $questionId, input: $input) {
      id
      questionId
      content
      createdAt
    }
  }
`;

export const getHomeScreenSearchData = gql`
  query GetHomeScreenSearchData($query: String!) {
    getHomeScreenSearchData(query: $query) {
      usersData {
        id
        firstname
        lastname
        email
        phone
        avatar
        background
      }
      organizationsData {
        id
        slug
        name
        email
        avatar
        background
        organization_type
      }
      stickersData {
        id
        title
        description
        cost
        status
        entity
        glow {
          glowStartDate
          glowEndDate
          glowColor
          glowStartDateTimeZone
          glowEndDateTimeZone
        }
        url
        thumbnailUrl
        campaignType
        priceRange
        quickCosts
        user {
          id
          firstname
          lastname
          avatar
          background
        }
        organization {
          id
          name
          avatar
          background
          organization_type
        }
        sweepstakesStickerId
      }
    }
  }
`;
